import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import QRCode from "react-qr-code";

const AssetQrCode = ({qrDialogOpen, setQrDialogOpen, selectedAsset}) => {
  return (
    <Dialog open={qrDialogOpen} onClose={() => setQrDialogOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Asset QR Code</DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{ py: 1,  flexDirection: "column",  alignItems: "center",  justifyContent: "center",  display: "flex" }}
          
          
          
          gap={2}
          >
          <QRCode
            value={
              selectedAsset?.BarCode ??
              selectedAsset?.BarCode?.toString() ??
              selectedAsset?.BarCode?.toString() ??
              ""
            }
            size={180}
          />
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {selectedAsset?.BarCode ??
              selectedAsset?.BarCode?.toString() ??
              selectedAsset?.BarCode?.toString() ??
              ""}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setQrDialogOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetQrCode;